import React from 'react';
import { Star, Quote, Facebook, Linkedin } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { testimonials } from '../data/mock';

export const Testimonials = () => {
  const getPlatformIcon = (platform) => {
    switch(platform) {
      case 'Facebook':
        return <Facebook className="w-4 h-4" />;
      case 'Google':
        return <span className="text-sm font-bold">G</span>;
      default:
        return <Linkedin className="w-4 h-4" />;
    }
  };

  return (
    <section id="testimonios" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            La satisfacción de nuestros clientes es nuestra mejor carta de presentación
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={testimonial.id}
              className="relative bg-white hover:shadow-2xl transition-all duration-300 border-2 border-blue-100 hover:border-blue-300 overflow-hidden group"
            >
              {/* Quote icon background */}
              <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity">
                <Quote className="w-24 h-24 text-blue-600" />
              </div>

              <CardContent className="p-8 relative">
                {/* Platform Badge */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2 bg-blue-100 px-3 py-1 rounded-full">
                    <div className="text-blue-700">
                      {getPlatformIcon(testimonial.platform)}
                    </div>
                    <span className="text-xs font-semibold text-blue-700">
                      {testimonial.platform}
                    </span>
                  </div>
                  
                  {/* Stars */}
                  <div className="flex gap-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={`${testimonial.id}-star-${i}`} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                </div>

                {/* Testimonial text */}
                <p className="text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-white font-bold text-lg">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-semibold text-blue-900">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-gray-500">
                      Cliente Verificado
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 bg-blue-100 px-6 py-3 rounded-full">
            <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
            <span className="font-semibold text-blue-900">
              4.9/5 estrellas - Basado en 200+ reseñas en redes sociales
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
